module.exports = __webpack_public_path__ + "img/90.4facdd33.jpg";